import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationToast } from 'dp-formio';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { TemplateObject } from '../models/template-object';

@Component({
  selector: 'lib-document-editor-sidebar',
  templateUrl: './document-editor-sidebar.component.html',
  styleUrls: ['./document-editor-sidebar.component.css']
})
export class DocumentEditorSidebarComponent implements OnInit {
  @Output()
  selectField: EventEmitter<{ key: string, label: string }> = new EventEmitter<{ key: string, label: string }>();
  @Input()
  template: TemplateObject;
  private labelKeyMap: Map<string, string> = new Map<string, string>();
  listData: { [key: string]: any }[] = [
    {
      text: 'item.label',
      value: 'item.id',
      category: 'Drag or click the field to insert.',
      htmlAttributes: { draggable: true }
    }
  ];
  public fields: object = { tooltip: 'category' };
  constructor(private toastr: ToastrService,
    private clipboardService: ClipboardService) { }

  ngOnInit(): void {
    this.listData = [];
    this.labelKeyMap = new Map<string, string>();
    this.template.fields.forEach(field => {
      this.listData.push({
        text: field.label,
        value: field.key,
        category: 'Drag or click the field to insert.',
        htmlAttributes: { draggable: true }
      });
      this.labelKeyMap.set(field.label, field.key);
    });
  }

  getItemData(label: string): { key: string, label: string } {
    if (this.labelKeyMap.has(label)) {
      return { key: this.labelKeyMap.get(label), label };
    } else {
      return { key: label, label };
    }
  }

  copy(key) {
    this.clipboardService.copy(key);
    this.toastr.success('Key copy successfully to clipboard', 'Copy successfully', {
      toastClass: 'notification-toast',
      messageClass: 'toast-copy-message',
      closeButton: true,
      enableHtml: true,
      toastComponent: NotificationToast
    });
  }
}
